import React from 'react';

import Typography from '@mui/material/Typography';

import DisplayName from 'client/app/apps/protocols/annotations/DisplayName';
import { StepContents } from 'client/app/apps/protocols/EditProtocol/DefineProtocol/StepCard/StepContents';
import { describeSourceDescription, ProtocolStepOutput } from 'common/types/Protocol';

type Props = {
  outputs: ProtocolStepOutput[];
  onDelete?: (contentIndex: number) => void;
};

export default function OutputStepContents({ outputs, onDelete }: Props) {
  if (outputs.length === 0) {
    return (
      <Typography variant="body1" component="i">
        Select an output from the elements in the workflow.
      </Typography>
    );
  }
  return (
    <StepContents
      items={outputs}
      getItemKey={({ id }) => id}
      renderItemContents={(output, _) => (
        <DisplayName
          name={output.displayName}
          tooltip={describeSourceDescription(output.sourceDescription)}
        />
      )}
      onDelete={onDelete}
    />
  );
}
